module.exports = __webpack_public_path__ + "img/image_icon.6f9c231.png";